module.exports = __webpack_public_path__ + "static/media/icon-right-arrow.535b07a4.svg";